import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { spamCheck } from "@forproxyband/react-tools";

import { ipv4Regex, ipv6Regex } from "../../../utils/constants";
import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import { useCheckSpamDBAdapter } from "../../../hooks";

import { BoxWrapper, Container, Input } from "../../../components";
import { Seo } from "../../../components/Seo/Seo";
import AccordionTable from "../../../components/common/AccordionTable";
import { Faq } from "../../../components/common/Faq/Faq";
import HeadUpperSeo from "../../../components/common/HeadUpperSeo";
import Spinner from "../../../components/common/Spinner";
import { Button } from "../../../components/ui/Button/Button";
import { TransitionBox } from "../../../components/ui/TransitionBox/TransitionBox";
import { Form, WrapperTable } from "./CheckDatabase.styled.";
import { addStyles } from "./addStyles";

import { Section } from "../../../components/common/Section/Section.styled";

const CheckDatabase = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [checkResult, setCheckResult] = useState([]);
  const [userIp, setUserIp] = useState("");

  const { t } = useTranslation();

  const {
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
    headerData,
  } = useCheckSpamDBAdapter();

  const errorMessage = () => toast.error(t("global.error"));

  const loaderCallback = res => {
    setShowLoader(res);
  };

  const setterSpamResultCallback = res => {
    const result = Object.entries(res).map(([name, result]) => ({
      name,
      result,
    }));

    setCheckResult(result);
  };

  const submitHandler = async () => {
    if (!ipv4Regex.test(userIp) && !ipv6Regex.test(userIp)) {
      return toast.error(t("checkSpamDB.incorrectIp"));
    }

    await spamCheck.check(
      userIp,
      setterSpamResultCallback,
      errorMessage,
      loaderCallback,
    );

    setUserIp("");
  };

  const isOpenTable = checkResult.length > 0 && !showLoader;

  return (
    <>
      <Section variant="start">
        <Container>
          <HeadUpperSeo />

          <BoxWrapper>
            <Form>
              <Input
                addStyles={addStyles.input}
                className="grey"
                fullWidth
                value={userIp}
                onChange={e => setUserIp(e.target.value)}
                placeholder={t("checkSpamDB.inputPlaceholder")}
              />

              <Button
                disable={showLoader}
                onClick={submitHandler}
                styles={addStyles.button}
              >
                {showLoader ? (
                  <Spinner text={t("checkSpamDB.button")} />
                ) : (
                  t("checkSpamDB.button")
                )}
              </Button>
            </Form>

            {isOpenTable && (
              <TransitionBox transformType={true} isOpen={isOpenTable}>
                <WrapperTable>
                  <AccordionTable
                    data={checkResult}
                    headerData={headerData}
                    renderRowContent={renderRowContent}
                    renderDropdownContent={renderDropdownContent}
                    renderHeaderTitle={renderHeaderTitle}
                    showStatus={false}
                  />
                </WrapperTable>
              </TransitionBox>
            )}
          </BoxWrapper>
        </Container>
      </Section>

      <Faq />
      <Seo />
    </>
  );
};

CheckDatabase.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);
};

export default CheckDatabase;
